<mat-list
  id="password-requirements-list"
  role="list">
  @for (req of reqList; track req) {
    <mat-list-item
      role="listitem"
      class="requirement-item">
      <span matListItemTitle class="list-line">
      <mat-icon [ngClass]="{
        'valid-req': req.valid,
        'invalid-req': !req.valid
      }">
          {{ req.valid ? 'check_circle' : 'check_circle_outline' }}
        </mat-icon>
        <!-- met / not met is otherwise only the icon's shape and color, and screen readers skip icons -->
        <span class="caption">{{ sysText?.atLeast }} {{ req.value + ' ' + req.description }}<span class="cdk-visually-hidden">, {{ req.valid ? sysText?.requirementMet_ariaLabel : sysText?.requirementNotMet_ariaLabel }}</span></span>
      </span>
    </mat-list-item>
  }
</mat-list>
